import { ArrowUpDown } from 'lucide-react';

export const SortControls = ({ sortBy, onSortChange, hasDistance }) => {
  const sortOptions = [
    { value: 'price', label: 'Prix' },
    { value: 'name', label: 'Nom' },
  ];

  if (hasDistance) {
    sortOptions.push({ value: 'distance', label: 'Distance' });
  }

  return (
    <div 
      data-testid="sort-controls"
      className="flex items-center justify-between p-4 bg-[#F3F4F6] dark:bg-gray-900 border-b border-gray-300 dark:border-gray-700"
    >
      <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
        <ArrowUpDown className="w-4 h-4" />
        <span className="text-xs font-bold uppercase tracking-widest">Trier par</span>
      </div>
      <div className="flex gap-4">
        {sortOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onSortChange(option.value)}
            data-testid={`sort-${option.value}`}
            className={`text-sm font-bold uppercase transition-colors ${
              sortBy === option.value
                ? 'text-[#FF4500] underline decoration-2 underline-offset-4 decoration-[#FF4500]'
                : 'text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
